import { render } from "./Footer.vue?vue&type=template&id=650806ba&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=650806ba&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-650806ba"

export default script